module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newDriver":"New driver"},"no":{"newDriver":"Ny sjåfør"}}')
  delete Component.options._Ctor
}
